import { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';


const ManualOrderSchema = Yup.object().shape({
    name: Yup.string().required('Name is required!')
    .matches(/^[A-Za-z\s]+$/, 'Name contains only alphabetic characters')
    .max(25)
    .test('no-whitespace', 'Name should not start or end with whitespace', value => {
        if (value) {
            return value === value.trim(); // Check if value is equal to its trimmed version
        }
        return true;
    }),
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required!')
      .max(50)
      .test('no-whitespace', 'Email should not start or end with whitespace', value => {
        if (value) {
            return value === value.trim(); // Check if value is equal to its trimmed version
        }
        return true;
    }),
    password:  Yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),


    partnerWebsiteId: Yup.object().shape({
        value: Yup.string().required('Role is required')
      }),

     phoneNumber:  Yup.number().required('Phone is required')

   
});

export {
    ManualOrderSchema
};